/** Whether a path stays on this site: rooted, not protocol-relative (`//host`), and without a backslash browsers read as `/`. */
export function isSitePath(path: string): boolean {
  return path.startsWith('/') && !path.startsWith('//') && !path.includes('\\')
}

/**
 * Where to go after signing in: the `from` a protected page put in the
 * location state, when it's a path on this site that `accept` allows. The
 * router refuses anything else, which would surface as a failed sign-in
 * after the sign-in had worked.
 */
export function returnPath<S>(state: S, fallback: string, accept: (path: string) => boolean = () => true): string {
  if (state && typeof state === 'object' && 'from' in state) {
    const from = state.from
    if (typeof from === 'string' && isSitePath(from) && accept(from)) return from
  }
  return fallback
}
